<template>
    <div>

        <div>
            <el-table class="mrt10" ref="table"　size="mini" :height="tableHeight/2" border :data="ggtableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                <el-table-column align="center" label="产品分类名" prop="vc_pztype" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产品名" prop="vc_pzname" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="规格名" prop="vc_name" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="英文名" prop="vc_ename" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产地" prop="vc_cd"></el-table-column>
                <el-table-column align="center" label="厂家" prop="vc_gykh"></el-table-column>
                <el-table-column align="center" label="包装规格" prop="vc_bzstyle"></el-table-column>
                <el-table-column align="center" label="包装单位" prop="vc_bzunit"></el-table-column>
                <el-table-column align="center" label="转换比率" prop="f_bl"></el-table-column>
                <el-table-column align="center" label="计量单位" prop="vc_unit"></el-table-column>
                <el-table-column align="center" label="单件净重" prop="f_weight"></el-table-column>
                <el-table-column align="center" label="件重单位" prop="vc_djunit"></el-table-column>
                <el-table-column align="center" label="产品属性" prop="i_flag">
                    <template slot-scope="scope">
                        <div>{{flagList.find(f=>f.i_flag==scope.row.i_flag).vc_flag}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="货物性质" prop="vc_type"></el-table-column>
                <el-table-column align="center" label="散水/非散水" prop="i_isbulk">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_isbulk==0?'非散水':'散水'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否传电商" prop="isec">
                    <template slot-scope="scope">
                        <div>{{scope.row.isec?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否计件" prop="isjian">
                    <template slot-scope="scope">
                        <div>{{scope.row.isjian?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否用包装物" prop="isusepack">
                    <template slot-scope="scope">
                        <div>{{scope.row.isusepack?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否启用" prop="isusepack">
                    <template slot-scope="scope">
                        <div>{{scope.row.isuse?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="卸货是否必检" prop="i_ismustcheck">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_ismustcheck?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="是否化验" prop="i_assayres">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_assayres?'是':'否'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="财务成本核算" prop="i_type_sel">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_type_sel?'按批次':'按产品'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="用友同步方式" prop="i_type_sel">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_syncyy_type==1?'按产品':'按规格'}}</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="ERP统计粒度" prop="i_ispno">
                    <template slot-scope="scope">
                        <div>{{scope.row.i_ispno==2?'规格':'批次'}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-input style="width: 220px" class="marr4" clearable size="mini" placeholder="产品名称" v-model="cpvc_name">
            </el-input>        <el-button class="marB10" icon="el-icon-search" circle @click="searchcpFun " size="mini" ></el-button>

            <el-table class="mrt10" @row-click="chooseRowFun"  ref="table"　size="mini" :height="tableHeight/2" border :data="cptableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                <!--                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>-->
                <el-table-column align="center" label="产品分类ID" prop="i_pztypeid" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产品分类" prop="vc_pztype" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产品ID" prop="i_pzid" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="产品名" prop="vc_pzname" show-overflow-tooltip></el-table-column>
            </el-table>
            <el-pagination  style="margin-top: 10px;text-align: right"
                            background
                            @current-change="cppageCurrentChange"
                            layout="total,prev, pager, next"
                            :current-page.sync="cpcurrentPage"
                            :total="cptotal"
                            :page-size="cppageSize">
            </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" size="mini"  :disabled="disabled" >{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="mini">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "TransferCpgg",
        components: {},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                cptableData:[],
                ggtableData:[],
                cpcurrentPage: 1,
                cppageSize: 20,
                cptotal:0,
                cpvc_name:'',
                chooseRow:'',
                // flagList:[],
                disabled:false,
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        this.ggtableData=JSON.parse(JSON.stringify(this.data.list));
                        this.flagList=this.data.flagList;
                        this.i_syncyy_type=this.ggtableData[0].i_syncyy_type;
                        this.i_flag=this.ggtableData[0].i_flag;
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {
            // this.findClassificationAttributes();
            this.getPztypeContents()
            // this.getProductSpecification()
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3;
                // if(this.tableHeight<60)this.tableHeight=60;
            },
            chooseRowFun(val){
                this.chooseRow=val
            },
            async getPztypeContents(){

                let param = {
                    currentPage:this.cpcurrentPage,
                    pageSize:this.cppageSize,
                    vc_name:this.cpvc_name,
                    i_syncyy_type:this.i_syncyy_type,
                    i_flag:this.i_flag,

                };
                let res = await API.getPztypeContents(param);
                if (res.code == 1) {
                    this.cptableData=res.data.list
                    this.cptotal=res.data.total;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            searchcpFun(){
                this.cpcurrentPage=1;
                //调用列表接口
                this.getPztypeContents();
            },
            cppageCurrentChange(val){
                // console.log(val,"pageval");
                this.cpcurrentPage=val;
                //调用列表接口
                this.getPztypeContents();
            },

            cancel(){
                this.$emit('close',null)
            },
            saveForm(){
                if(this.chooseRow){
                    this.ggtableData.map(x=>{
                            x.isyw=0
                            x.vc_app=this.baseerp;
                            x.i_pid=this.chooseRow.i_pzid
                        }

                    );
                    this.disabled=true;
                    this.productSpecifySwitch()
                }else {
                    this.$message.warning('请选择要转移的产品')
                }

            },
            async productSpecifySwitch() {
                let param={
                    list:this.ggtableData,
                    isyw:0,
                    vc_app:this.baseerp,
                };
                let res = await API.productSpecifySwitch(param);
                if (res.code == 1) {
                    this.$emit('close','save');
                    this.$message.success(res.message);
                    this.disabled=false
//console.log(res, "addOrupdateProductSpecification");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.disabled=false
                    this.$message.error(res.message);
                }else{
                    this.disabled=false
                    this.$message.error(res.message);
                };
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>